import React from "react";
import { Form } from "react-bootstrap";
import { getInstantValidationState } from '../../../utils/realTimeValidationUtils';

import './VAS.scss';

const VAS = ({handleFormData, values, fieldErrors = {}, touchedFields = {} }) => {
  // Get instant validation state for real-time feedback
  const validationState = getInstantValidationState('vasScore', fieldErrors, touchedFields, values.vasScore);

  return (
    <div className="modern-assessment">
      <h2 className="assessment-title">Visuele Analoge Pijnschaal</h2>
      <div className={validationState.formGroupClasses}>
        <label className="modern-form-label required">
          1. Hoe erg is uw pijn vandaag?
        </label>
        <p className="modern-form-help">
          Van 0 (helemaal geen pijn) tot 10 (ergst denkbare pijn)
        </p>
        <div className={validationState.inputClasses('modern-pain-slider')}>
          <input
            type="range"
            className={validationState.inputClasses('modern-range-slider')}
            name="vasScore"
            required
            value={values.vasScore || ''}
            min="0"
            max="10"
            step="0.01"
            onChange={(event) => handleFormData("vas", "vasScore", event.target.value)}
            aria-label="Pijnschaal van 0 tot 10"
            {...validationState.ariaProps}
          />
          <input
            type="number"
            className={validationState.inputClasses('modern-number-input')}
            name="vasScore"
            required
            min="0"
            max="10"
            step="0.01"
            value={values.vasScore || ''}
            onChange={(event) => handleFormData("vas", "vasScore", event.target.value.trim())}
            aria-label="Pijnwaarde invoer"
            {...validationState.ariaProps}
          />
        </div>
        
      </div>
    </div>
  );
}

export default VAS